
import { defaultStepPropertyTypeListEnum, questionTypeEnum } from "assets/constants";

export const addVisibilityToProperties = (properties, questionKeyMapping, isServiceSelected, userData) => {
    let isVisible = true;
    let isVisibleQuestion = true;
    let hasFirstValidInput = false;

    return properties.map((property, index, arr) => {
        const { type, value } = property;

        if (!type) {
            return { ...property, visible: true };
        }

        if (type === defaultStepPropertyTypeListEnum.question || type === questionTypeEnum.multiSelection || type === questionTypeEnum.freeText) {
            const { questionKey } = property?.value?.question || {};
            const { isMandatory } = property?.value?.questionConfig || {};

            const serviceInContext = value.questionConfig?.serviceInContext
            const selectedServiceFilter = value.questionConfig?.selectedServiceFilter

            const { hasRegex, regex } = property?.value?.questionConfig || {};
            const validInput = questionKeyMapping && hasRegex && !!regex?.length
                ? new RegExp(regex).test(questionKeyMapping[questionKey])
                : true;

            if (!hasFirstValidInput && validInput)
                hasFirstValidInput = true;
            const isValidQuestion = !userData?.not_valid_questions?.includes(questionKey);
            isVisibleQuestion = ((serviceInContext && selectedServiceFilter && !isServiceSelected) || (isServiceSelected && serviceInContext && selectedServiceFilter && !isValidQuestion)) ? false : true

            const currentPropertyWithVisibility = { ...property, visible: isVisibleQuestion };

            if (!isMandatory || questionKeyMapping?.hasOwnProperty(questionKey)) {
                isVisible = true;
            } else {
                isVisible = false;
            }
            return currentPropertyWithVisibility;
        }

        return { ...property, visible: isVisible };
    });
};